import React, {useContext, useEffect, useState} from "react";
import {ThemeContext} from "@/contexts/ThemeContext";

import Icon from "@/components/Global/Icon/Icon";
import RenderIf from "@/components/Global/RenderIf/RenderIf";
import Insight from "@/components/BespokeTest/Insight/Insight";
import {config} from "@/config";
import trustpilotImage from "@/assets/img/trustpilot-white.webp";
import trustpilotImage4Stars from "@/assets/img/trustpilot-4.webp";

import styles from "./BespokeHeader.module.scss";
import {useDispatch} from "react-redux";
import {getBannerSettings} from "@/features/orders";
import {BlackFridayForth, BlackFridayEdge} from "@/components/Global/Banners";

const INITIAL_BANNER_SETTINGS = {
  showForth: false,
  showEdge: false,
  showBiomarkerTracking: false,
};

export default function BespokeHeader({
  maxPlusTestInDays = 0,
  showFreeDeliveryItem = true,
  partnerLogo,
  partnerRequestCode,
  ...rest
}) {
  const [showBannersSetting, setShowBannersSetting] = useState(INITIAL_BANNER_SETTINGS);
  const {showForth = false, showEdge = false, showBiomarkerTracking = false} = showBannersSetting;

  const trustpilotLink =
    config.websiteId == 1 || config.websiteId == 3
      ? "https://uk.trustpilot.com/review/forthwithlife.co.uk"
      : "https://uk.trustpilot.com/review/forthedge.co.uk";

  const {variant} = useContext(ThemeContext);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBannerSettings()).then(({payload: response}) => {
      if (!response.error) {
        setShowBannersSetting(response);
      }
    });
  }, []);

  const removePadding =
    (showEdge && config.websiteId == 2) ||
    (showForth && config.websiteId == 1) ||
    (showBiomarkerTracking && config.websiteId == 3);

  const edgeIconLogo = variant == "light" ? "edge-icon-gradient" : "edge-white-logo";
  const trustpilotImageSrc = [1, 2, 3].includes(config.websiteId) ? trustpilotImage4Stars : trustpilotImage;
  const logoStyle = config.websiteId == 1 || config.websiteId == 3 ? styles.forthLogo : styles.edgeLogo;

  let websiteUrl = "https://www.forthwithlife.co.uk";
  if (config.websiteId == 1 || config.websiteId == 3) {
    websiteUrl = "https://www.forthwithlife.co.uk";
  } else if (config.websiteId == 2) {
    websiteUrl = "https://www.sportsbloodtests.co.uk";
  }

  const referrer = localStorage.getItem("referrer");
  if (referrer && referrer != '""') {
    if (
      !referrer.includes("app") &&
      !referrer.includes("shop") &&
      !referrer.includes("localhost") &&
      !referrer.includes("10.0.2.2")
    ) {
      websiteUrl = referrer.replace(/^"(.*)"$/, "$1");
    }
  }

  return (
    <div className="row align-items-center" {...rest}>
      <div className="col-12 col-md py-3">
        <RenderIf isTrue={partnerLogo && partnerRequestCode}>
          <a href={`https://biomarkertracking.com/${partnerRequestCode}`} aria-label="Go to shop">
            <img src={partnerLogo} className={styles.partnerLogo} />
          </a>
        </RenderIf>
        <RenderIf isTrue={!partnerLogo}>
          <a href={websiteUrl} aria-label="Go to shop">
            <Icon
              icon={config.websiteId == 1 || config.websiteId == 3 ? "forth-brand-copy-icon" : edgeIconLogo}
              className={`mx-auto mx-md-0 ${logoStyle}`}
            />
          </a>
        </RenderIf>
      </div>
      <RenderIf isTrue={!partnerLogo && !window.config.isWhiteLabelApp}>
        <div className="col-12 col-md-auto py-3">
          <Insight resultsInDays={maxPlusTestInDays} showFreeDeliveryItem={showFreeDeliveryItem} />
        </div>
        <div className={`col-12 g-0 ${styles.trustpilotBanner}`} data-padding={!removePadding}>
          <a href={trustpilotLink} target="_blank" rel="noopener noreferrer">
            <img
              src={trustpilotImageSrc}
              alt="forth trustpilot"
              className={styles.trustpilotImage}
              width={191}
              height={20}
            />
          </a>
        </div>
      </RenderIf>
      <RenderIf isTrue={showEdge && config.websiteId == 2}>
        <BlackFridayEdge />
      </RenderIf>
      <RenderIf isTrue={(showForth && config.websiteId == 1) || (showBiomarkerTracking && config.websiteId == 3)}>
        <BlackFridayForth />
      </RenderIf>
    </div>
  );
}
